export const COMMON_DEFAULT_NUMBER_CONSTANTS = {
	DECIMAL_SEPARATOR: '.',
	GROUP_SEPARATOR: ' ',
	DIGITS_AFTER_DECIMAL: 2,
};
